module.exports = __webpack_public_path__ + "static/media/13PerformancePhotos.5752f78a.jpeg";